"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.search");
var _member_label = require("@/api/member/member_label.js");
var _common = require("@/api/common.js");
var _MemberLabelFormPane = _interopRequireDefault(require("./MemberLabelFormPane"));
var _MemberLabelCardPane = _interopRequireDefault(require("./MemberLabelCardPane"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberLabelTablePane',
  components: {
    MemberLabelFormPane: _MemberLabelFormPane.default,
    MemberLabelCardPane: _MemberLabelCardPane.default
  },
  data: function data() {
    return {
      imgAccessDomain: '',
      dialogVisible: false,
      // 是否显示添加用户标签的抽屉
      dialogVisibleAddCard: false,
      // 是否显示添加卡号的抽屉
      listQuery: {
        page: 1,
        limit: 10,
        keywords: ''
      },
      tableData: [],
      total: 0,
      loading: false,
      tableKey: 0,
      currentFnId: '',
      // 当前操作的标签ID
      currentRow: null // 当前操作的行数据
    };
  },
  created: function created() {
    this.getImageAccessDomain();
    this.search();
  },
  methods: {
    handleSuccess: function handleSuccess() {
      this.dialogVisible = false;
      this.dialogVisibleAddCard = false;
      this.currentFnId = '';
      this.search();
    },
    handleClose: function handleClose() {
      // 关闭抽屉
      this.dialogVisible = false;
      this.dialogVisibleAddCard = false;
      this.currentFnId = '';
    },
    getImageAccessDomain: function () {
      var _getImageAccessDomain = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return (0, _common.imageAccessDomain)();
            case 1:
              response = _context.sent;
              this.imgAccessDomain = response.data;
              console.log(response);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getImageAccessDomain() {
        return _getImageAccessDomain.apply(this, arguments);
      }
      return getImageAccessDomain;
    }(),
    handleUserLabelUpdate: function handleUserLabelUpdate(row) {
      // 编辑用户标签
      this.currentFnId = row.fnId;
      this.dialogVisible = true;
    },
    handleUserLabelAdd: function handleUserLabelAdd() {
      // 添加用户标签
      this.currentFnId = null;
      this.dialogVisible = true;
    },
    handleAddCard: function handleAddCard(row) {
      // 添加卡号
      this.currentFnId = row.fnId;
      this.dialogVisibleAddCard = true;
    },
    handleDelete: function handleDelete(row) {
      var _this = this;
      // 删除用户标签
      console.log('handleDelete', row);

      // 添加确认弹窗
      this.$confirm('确定要删除该用户标签吗？此操作不可恢复', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 用户点击确定，调用删除接口
        (0, _member_label.deleteMemberLabel)(row.fnId).then(function (response) {
          if (response.code === 0) {
            _this.$message.success('删除成功');
            // 刷新列表
            _this.handleFilter();
          } else {
            _this.$message.error(response.message || '删除失败');
          }
        }).catch(function (error) {
          console.error('删除用户标签失败:', error);
          _this.$message.error('删除用户标签失败: ' + (error.message || '未知错误'));
        });
      }).catch(function () {
        // 用户点击取消
        _this.$message.info('已取消删除操作');
      });
    },
    handleImportCard: function handleImportCard(row) {
      // 导入卡号
      console.log('handleImportCard', row);

      // 保存当前行信息
      this.currentRow = row;

      // 触发文件选择
      this.$refs.fileInput.click();
    },
    handleSyncCdpCard: function handleSyncCdpCard(row) {
      var _this2 = this;
      // 同步cdp会员

      // 添加确认弹窗
      this.$confirm('确定要同步CDP会员信息吗？此操作可能需要一些时间完成。请确保同步的CDP分组ID正确', '同步确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 用户点击确定，调用同步CDP会员信息接口
        (0, _member_label.syncCdpGroupVip)(row.fnId).then(function (response) {
          if (response.code === 0) {
            _this2.$message.success(response.message || '同步请求已提交，请稍后查看结果');
          } else {
            _this2.$message.error(response.message || '同步失败');
          }
        }).catch(function (error) {
          console.error('同步CDP会员信息失败:', error);
          _this2.$message.error('同步CDP会员信息失败: ' + (error.message || '未知错误'));
        });
      }).catch(function () {
        // 用户点击取消
        _this2.$message.info('已取消同步操作');
      });
    },
    // 处理文件选择变化
    handleFileChange: function handleFileChange(event) {
      var file = event.target.files[0];
      if (!file) {
        return;
      }

      // 验证文件类型
      var fileName = file.name.toLowerCase();
      if (!fileName.endsWith('.xls') && !fileName.endsWith('.xlsx')) {
        this.$message.error('只支持上传Excel文件(.xls, .xlsx)');
        // 清空文件输入框
        event.target.value = '';
        return;
      }

      // 执行文件上传
      this.uploadExcelFile(file);

      // 清空文件输入框
      event.target.value = '';
    },
    // 上传Excel文件
    uploadExcelFile: function uploadExcelFile(file) {
      var _this3 = this;
      // 显示上传loading
      var loading = this.$loading({
        lock: true,
        text: '文件上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // 创建FormData对象
      var formData = new FormData();
      formData.append('file', file);
      formData.append('labelId', this.currentRow.fnId);
      // 调用上传接口
      (0, _member_label.uploadFile)(formData).then(function (response) {
        loading.close();
        if (response.code === 200) {
          _this3.$message.success(response.message || '上传成功');
          // 如果需要刷新数据可以在这里调用this.handleFilter()
        } else {
          _this3.$message.error(response.message || '上传失败');
        }
      }).catch(function (error) {
        loading.close();
        console.error('文件上传失败:', error);
        _this3.$message.error('文件上传失败: ' + (error.message || '未知错误'));
      });
    },
    handleListCard: function handleListCard(row) {
      // 触发父组件打开新的tab页面
      this.$emit('openMemberListTab', row);
    },
    // 清空标签关联
    handleClearLabel: function handleClearLabel(row) {
      var _this4 = this;
      // 添加确认弹窗
      this.$confirm('确定要清空该标签的所有关联会员吗？此操作不可恢复', '清空确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 用户点击确定，调用清空接口
        (0, _member_label.delLabelRel)(row.fnId).then(function (response) {
          if (response.code === 200) {
            _this4.$message.success(response.message || '清空成功');
            // 刷新列表
            _this4.handleFilter();
          } else {
            _this4.$message.error(response.message || '清空失败');
          }
        }).catch(function (error) {
          console.error('清空标签关联失败:', error);
          _this4.$message.error('清空标签关联失败: ' + (error.message || '未知错误'));
        });
      }).catch(function () {
        // 用户点击取消
        _this4.$message.info('已取消清空操作');
      });
    },
    search: function search() {
      this.listQuery.page = 1;
      this.handleFilter();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.handleFilter();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.search();
    },
    handleFilter: function handleFilter() {
      var _this5 = this;
      this.loading = true;
      (0, _member_label.queryMemberLabelPage)(this.listQuery).then(function (res) {
        _this5.tableData = res.records;
        _this5.total = res.total;
        _this5.loading = false;
      }, function () {
        _this5.loading = false;
      });
    },
    // 导入模板
    handleImportTemplate: function () {
      var _handleImportTemplate = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, blob, link, url, _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _member_label.downloadImportTemplate)();
            case 1:
              response = _context2.sent;
              // 创建一个 Blob 对象
              blob = new Blob([response], {
                type: 'application/vnd.ms-excel'
              }); // 创建一个链接元素
              link = document.createElement('a'); // 创建一个 URL 对象
              url = window.URL.createObjectURL(blob);
              link.href = url;
              link.download = '导入模板.xlsx';
              // 触发下载
              link.click();
              // 释放 URL 对象
              window.URL.revokeObjectURL(url);
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t = _context2["catch"](0);
              console.error('模板下载失败:', _t);
              this.$message.error('模板下载失败: ' + (_t.message || '未知错误'));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function handleImportTemplate() {
        return _handleImportTemplate.apply(this, arguments);
      }
      return handleImportTemplate;
    }()
  }
};